@if(isOpen){
<div class="overlay">
    &nbsp;
</div>
<div *ngIf="localService.languageContent && localService.languageContent.seller"
    class="billing-adjustment-box-wrapper center-full {{localService.selectedLanguageCode}}">
    <div class="side_popup_header">
        <span>{{localService.languageContent.seller.bill_adjust}}</span>
        <button class="button_icon" (click)="onAction(1)">close</button>
    </div>
    <div class="side_popup_body">
        <div class="row row_header freeze_height">
            <div class="col-1">
                {{localService.languageContent.common.is_active}}
            </div>
            <div class="col-3">
                *{{localService.languageContent.seller.value_from}}
            </div>
            <div class="col-3">
                *{{localService.languageContent.seller.value_to}}
            </div>
            <div class="col-3">
                {{localService.languageContent.seller.set_value}}
            </div>
            <div class="col-2">
                {{localService.languageContent.common.action}}
            </div>
        </div>
        <div class="custom_rows_body" style="max-height: calc(90vh - 175px);" *ngIf="items">
            <div class="row styled_row" *ngFor="let item of items">
                <div class="col-1">
                    <button class="material-icons button_icon icon_adjust" *ngIf="item.key"
                        title="{{item.v5 == '1' ? localService.languageContent.table.make_inactive : localService.languageContent.table.make_active}}"
                        (click)="onActiveInactiveStatus(item.key)"
                        [ngStyle]="{'color': item.v5 == '1' ? 'yellowgreen' : 'orangered' }">{{item.v5 == '1' ?
                        "toggle_on" : "toggle_off"}}</button>
                </div>
                <div class="col-3">
                    <span class="en" style="opacity: 0.7;">eg: 0.01</span>
                    <input autocomplete="off" type="number" class="number" [ngClass]="item.v2 ? 'en' : ''"
                        [(ngModel)]="item.v2" style="width:calc(95% - 150px);text-align:right;"
                        placeholder="*{{localService.languageContent.seller.value_from}}"
                        title="*{{localService.languageContent.seller.value_from}}" />
                </div>
                <div class="col-3">
                    <span class="en" style="opacity: 0.7;">eg: 0.99</span>
                    <input autocomplete="off" type="number" class="number" [ngClass]="item.v3 ? 'en' : ''"
                        [(ngModel)]="item.v3" style="width:calc(95% - 150px);text-align:right;"
                        placeholder="*{{localService.languageContent.seller.value_to}}"
                        title="*{{localService.languageContent.seller.value_to}}" />
                </div>
                <div class="col-3">
                    <span class="en" style="opacity: 0.7;">eg: 1</span>
                    <input autocomplete="off" type="number" class="number" [ngClass]="item.v4 ? 'en' : ''"
                        [(ngModel)]="item.v4" style="width:calc(95% - 150px);text-align:right;"
                        (keypress)="localService.isNumberOnly($event,numericConfigSetValue)"
                        placeholder="*{{localService.languageContent.seller.set_value}}"
                        title="{{localService.languageContent.seller.set_value}}" />
                </div>
                <div class="col-2" style="text-align: center;">
                    <button type="button" class="btn btn-primary" style="margin:5px;"
                        (click)="onAction(2,item.key)">{{item.key ? localService.languageContent.common.update :
                        localService.languageContent.common.add}}</button>
                </div>
            </div>
        </div>
    </div>
</div>
}